import UiConfigObject from '../../ui-config.json';

export default UiConfigObject;
